import MappingVisitor from "data/util/MappingVisitor";
import MappingStore, { isExcluded } from "data/MappingStore";
import TableAccess from "data/util/TableAccess";
import TableStore from "data/TableStore";
import { addNew } from "data/SuperRecordStore";

class SuperRecordMappingVisitor extends MappingVisitor {
    constructor(state) {
        super(
            MappingStore.getState(),
            new TableAccess(TableStore.getState()),
        );
        this.srstate = state;
    }

    getState() {
        return this.srstate;
    }

    doGlobalAssoc(
        ctx,
        target,
        excluded,
        fieldInfo,
        sourceValue,
        createIfMissing,
    ) {
        if (!createIfMissing) return;
        this.__forEach(sourceValue, it => {
            const lo = this.__getTargetIdLO(it, target, fieldInfo);
            if (!lo.hasValue()) return;
            const id = lo.getValueEnforcing();
            if (isExcluded(this.state, target.id, fieldInfo.logicalColumn, id)) return;
            if (this.srstate[id] != null) return;
            this.srstate = addNew(this.srstate, fieldInfo.otherEntityKey, id);
        });
        return super.doGlobalAssoc(
            ctx,
            target,
            excluded,
            fieldInfo,
            sourceValue,
            createIfMissing
        );
    }

}

export default SuperRecordMappingVisitor;



// WEBPACK FOOTER //
// ./app/data/SuperRecordMappingVisitor.js